import { _values, tsValidateArray, tsValidateBoolean, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { ABTestValue } from './types.js';
import { DBDef_NoteTemplate } from '@app/advisor-content-shared';
const ABTestValues = _values(ABTestValue);
const Validator_ABTestValue = tsValidateValue(ABTestValues);
const Validator_MandatoryPropsAdvisorConfiguration = {
    label: tsValidateString(),
    contextRuleIds: tsValidateArray(tsValidateString(), false),
    organizationId: tsValidateString(),
    kbVersionId: tsValidateUniqueId,
    enableSurvey: tsValidateBoolean(),
    devInstance: tsValidateBoolean(),
    enableDocumentation: tsValidateBoolean(),
    enableAgl: tsValidateBoolean(),
    useEhrOrderId: tsValidateBoolean(),
    noteIds: tsValidateArray(tsValidateUniqueId),
    aglFixing: {
        labs: {
            enabled: tsValidateBoolean(),
            suffix: tsValidateString(undefined, false),
        },
        radiology: {
            enabled: tsValidateBoolean(),
            suffix: tsValidateString(undefined, false),
        }
    },
    abTesting: {
        magicWand: Validator_ABTestValue,
        catchUp_vitals: Validator_ABTestValue,
        catchUp_recap: Validator_ABTestValue,
        pertinentData: Validator_ABTestValue,
    }
};
const Validator_GeneratedProps = {};
export const DBDef_AdvisorConfiguration = {
    modifiablePropsValidator: Validator_MandatoryPropsAdvisorConfiguration,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'advisor-configurations',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'advisor-configurations'
    },
    backend: {
        name: 'advisor-configurations'
    },
    entityName: 'Advisor Configurations',
    dependencies: {
        contextRuleIds: {
            dbKey: 'context-rule',
            fieldType: 'string[]',
        },
        organizationId: {
            dbKey: 'organizations',
            fieldType: 'string',
        },
        kbVersionId: {
            dbKey: 'artifacts',
            fieldType: 'string'
        },
        noteIds: {
            dbKey: DBDef_NoteTemplate.dbKey,
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map